import * as React from 'react';
import { LessonPreview } from '../types';
import style from '../style.module.scss';
import { paths } from 'config/path_helpers';
import cx from 'classnames';

interface LessonSampleProps {
  lessons: LessonPreview[];
}

export default class LessonSamples extends React.Component<LessonSampleProps> {
  render() {
    return (
      <div className={style.sampleBox}>
        <div className={style.sampleDescription}>
          <p>
            <strong>Try It</strong>
          </p>
          <p>Sample a short video lesson on an ACT topic.</p>
        </div>
        <div>
          <div className={style.itemPreviews}>
            {this.renderLessonPreview(this.props.lessons[0])}
            {this.renderLessonPreview(this.props.lessons[1])}
          </div>
          <div className={style.itemPreviews}>
            {this.renderLessonPreview(this.props.lessons[2])}
            {this.renderLessonPreview(this.props.lessons[3])}
          </div>
        </div>
      </div>
    );
  }

  renderLessonPreview(lesson: LessonPreview) {
    return (
      <a
        className={cx('btn btn-multi-line btn-default', style.itemPreview)}
        href={paths.lessonTour(lesson.slug, 0)}
        key={lesson.id}>
        <p>
          <strong>{lesson.examSection}</strong>
        </p>
        <p className={style.subtitle}>{lesson.subject}</p>
        <p className={style.subtitle}>
          {lesson.title} ({lesson.length})
        </p>
      </a>
    );
  }
}
